var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 91.6668C73.0115 91.6668 91.6663 73.012 91.6663 50.0002C91.6663 26.9883 73.0115 8.3335 49.9997 8.3335C26.9878 8.3335 8.33301 26.9883 8.33301 50.0002C8.33301 73.012 26.9878 91.6668 49.9997 91.6668Z",
    stroke: "#E87166",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 37.5L37.5 62.5",
    stroke: "#E87166",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 37.5L62.5 62.5",
    stroke: "#E87166",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.432e467e51d492f1b5f4861bf2b76e01.svg";
export { ForwardRef as ReactComponent };